import React, { useEffect } from "react";
import moment from "moment-timezone";
import { timeSlots } from "../../common-data/DropdowData";
import { FORMATTED_TODAY_DATE_YYYYMMDD } from "../../common-data/Converts";
import { getBCAPendingIcon } from "../../pt-trials/member-report/MemberReportMocks";

const CommandCenterFilter = ({ allFilters, setAllFilters }) => {
  const currentMoment = moment().tz("Asia/Kolkata");
  const currentHour = currentMoment.hour();
  const currentDate = currentMoment.format("YYYY-MM-DD");

  const currentSlotIndex = Math.max(0, currentHour - 5);

  const isToday = allFilters.selectedDate === currentDate;
  const isSingleDay = allFilters.selectedDate === allFilters.selectedDateEnd;

  const effectiveCurrentSlotIndex =
    isToday && isSingleDay ? currentSlotIndex : -1;

  const selectedCheckinTimes = Array.isArray(allFilters.selectedCheckinTimes)
    ? allFilters.selectedCheckinTimes
    : [];

  const getFilteredTimeSlots = () => {
    if (!isSingleDay) {
      return timeSlots;
    }

    if (isToday && isSingleDay) {
      return timeSlots.filter((_, index) => index <= currentSlotIndex);
    }

    return timeSlots;
  };

  const filteredTimeSlots = getFilteredTimeSlots();

  const handleDateChange = (event, name) => {
    const selectedDate = event.target.value;

    setAllFilters((prev) => {
      const updates = {
        ...prev,
        [name]: selectedDate,
        selectedCheckinTimes: [],
      };

      if (
        name === "selectedDate" &&
        prev.selectedDateEnd &&
        selectedDate > prev.selectedDateEnd
      ) {
        updates.selectedDateEnd = selectedDate;
      }

      if (
        name === "selectedDateEnd" &&
        prev.selectedDate &&
        selectedDate < prev.selectedDate
      ) {
        updates.selectedDate = selectedDate;
      }

      return updates;
    });
  };

  const handleSlotClick = (slot, index) => {
    const isSelected = selectedCheckinTimes.some(
      (selected) => selected.value === slot.value
    );

    if (isSelected) {
      const updatedSelection = selectedCheckinTimes.filter(
        (selected) => selected.value !== slot.value
      );
      setAllFilters((prev) => ({
        ...prev,
        selectedCheckinTimes: updatedSelection,
      }));
    } else {
      const slotWithIndex = { ...slot, index };
      setAllFilters((prev) => ({
        ...prev,
        selectedCheckinTimes: [...selectedCheckinTimes, slotWithIndex],
      }));
    }
  };

  useEffect(() => {
    if (!allFilters.selectedDate) {
      setAllFilters((prev) => ({
        ...prev,
        selectedDate: FORMATTED_TODAY_DATE_YYYYMMDD,
        selectedDateEnd: FORMATTED_TODAY_DATE_YYYYMMDD,
      }));
    }
  }, [allFilters.selectedDate]);

  return (
    <section
      className="mr-timeslot mt30"
      role="group"
      aria-label="Date and time slot selector"
    >
      <div className="mr-timeslot__date-section">
        <div className="mr__dateslot-section">
          <header className="mr-timeslot__header">
            {getBCAPendingIcon()}
            <h3 className="mr-timeslot__title">Time Slot</h3>
          </header>
        </div>

        <div className="mr-timeslot__right-filters">
          <input
            id="selectedDate"
            type="date"
            value={allFilters.selectedDate || FORMATTED_TODAY_DATE_YYYYMMDD}
            onChange={(e) => handleDateChange(e, "selectedDate")}
            className={`mr-timeslot__date-input ${
              allFilters.selectedDate ? "date-has-value" : ""
            }`}
            max={currentDate}
          />

          <input
            id="selectedDateEnd"
            type="date"
            value={allFilters.selectedDateEnd || FORMATTED_TODAY_DATE_YYYYMMDD}
            onChange={(e) => handleDateChange(e, "selectedDateEnd")}
            className={`mr-timeslot__date-input ${
              allFilters.selectedDateEnd ? "date-has-value" : ""
            }`}
            min={allFilters.selectedDate || FORMATTED_TODAY_DATE_YYYYMMDD}
            max={currentDate}
          />
        </div>
      </div>

      <div
        className="mr-timeslot__scroller"
        tabIndex={0}
        aria-label="Available time slots"
      >
        <div className="mr-timeslot__list">
          {filteredTimeSlots.map((slot, index) => {
            const isSelected = selectedCheckinTimes.some(
              (selected) => selected.value === slot.value
            );
            const isCurrent = index === effectiveCurrentSlotIndex;

            return (
              <button
                key={index}
                className={`mr-timeslot__btn ${
                  isSelected ? "is-selected" : ""
                } ${isCurrent ? "is-current" : ""}`}
                type="button"
                aria-pressed={isSelected}
                aria-current={isCurrent ? "time" : undefined}
                data-slot-id={index}
                aria-label={`${isSelected ? "Selected: " : ""}${
                  isCurrent ? "Now: " : ""
                }${slot.label}`}
                onClick={() => handleSlotClick(slot, index)}
              >
                {slot.label}
                {isCurrent && (
                  <span className="mr-timeslot__now" aria-hidden="true">
                    <span className="mr-timeslot__now-ping" />
                    <span className="mr-timeslot__now-dot" />
                  </span>
                )}
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default CommandCenterFilter;
